"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dialog = _interopRequireDefault(require("britive-design-system/core/components/dialog"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _commonUtils = require("../../../utils/common-utils");

var _commonConstants = require("../../../utils/common-constants");

var _AddPolicy = _interopRequireDefault(require("../add/AddPolicy"));

var _utils = require("../utils");

var _constants = require("./constants");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _reactRedux = require("react-redux");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var EditPolicy = function EditPolicy(_ref) {
  var usersData = _ref.usersData,
      groupsData = _ref.groupsData,
      serviceIdentitiesData = _ref.serviceIdentitiesData,
      tokensData = _ref.tokensData,
      usersDataStatus = _ref.usersDataStatus,
      groupsDataStatus = _ref.groupsDataStatus,
      serviceIdentitiesDataStatus = _ref.serviceIdentitiesDataStatus,
      tokensDataStatus = _ref.tokensDataStatus,
      consumersList = _ref.consumersList,
      resetActionsData = _ref.resetActionsData,
      editPolicyErrors = _ref.editPolicyErrors,
      editPolicyStatus = _ref.editPolicyStatus,
      loadedPolicy = _ref.loadedPolicy,
      loadedPolicyStatus = _ref.loadedPolicyStatus,
      setPageHeader = _ref.setPageHeader,
      fetchUsers = _ref.fetchUsers,
      fetchGroups = _ref.fetchGroups,
      fetchServiceIdentities = _ref.fetchServiceIdentities,
      fetchTokens = _ref.fetchTokens,
      fetchPermissionsList = _ref.fetchPermissionsList,
      fetchConsumersList = _ref.fetchConsumersList,
      fetchPermissionDetails = _ref.fetchPermissionDetails,
      fetchPermissionActions = _ref.fetchPermissionActions,
      fetchRolesList = _ref.fetchRolesList,
      fetchRoleDetails = _ref.fetchRoleDetails,
      initSpinnerOverlay = _ref.initSpinnerOverlay,
      updatePolicy = _ref.updatePolicy,
      loadPolicy = _ref.loadPolicy,
      openNotification = _ref.openNotification,
      history = _ref.history,
      permissionsListStatus = _ref.permissionsListStatus,
      getApplicationsList = _ref.getApplicationsList,
      applicationsListStatus = _ref.applicationsListStatus,
      applicationsListData = _ref.applicationsListData,
      loadedPolicyJSON = _ref.loadedPolicyJSON,
      loadedPolicyJSONStatus = _ref.loadedPolicyJSONStatus,
      loadPolicyJSON = _ref.loadPolicyJSON,
      resetPolicy = _ref.resetPolicy,
      resetPolicyJSON = _ref.resetPolicyJSON,
      consumersListStatus = _ref.consumersListStatus,
      consumerEntityId = _ref.consumerEntityId,
      redirectPath = _ref.redirectPath,
      validateChannelListStatus = _ref.validateChannelListStatus,
      validateChannelListError = _ref.validateChannelListError,
      validateChannelList = _ref.validateChannelList,
      isConditionTypeJSON = _ref.isConditionTypeJSON;

  var _useParams = (0, _reactRouter.useParams)(),
      id = _useParams.id;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      resetModalOpen = _useState2[0],
      setResetModalOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      policy = _useState4[0],
      setPolicy = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      policyJSON = _useState6[0],
      setPolicyJSON = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      resourcesLoading = _useState8[0],
      setResourcesLoading = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      notificationMediumDetails = _useState10[0],
      setNotificationMediumDetails = _useState10[1];

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer, _state$policyReducer$;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : (_state$policyReducer$ = _state$policyReducer.add) === null || _state$policyReducer$ === void 0 ? void 0 : _state$policyReducer$.notificationMedium;
  }),
      notificationMediumList = _useSelector.data,
      notificationMediumDetailsStatus = _useSelector.status;

  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(loadedPolicy) && !policy) {
      if (loadedPolicy !== null && loadedPolicy !== void 0 && loadedPolicy.condition) {
        var approver = loadedPolicy === null || loadedPolicy === void 0 ? void 0 : loadedPolicy.condition;

        if (!(0, _isEmpty.default)(approver === null || approver === void 0 ? void 0 : approver.approval)) {
          var _approver$approval;

          var genre_ids = approver === null || approver === void 0 ? void 0 : (_approver$approval = approver.approval) === null || _approver$approval === void 0 ? void 0 : _approver$approval.notificationMedium;
          var filteredGenre = notificationMediumList === null || notificationMediumList === void 0 ? void 0 : notificationMediumList.filter(function (element) {
            return genre_ids.includes(element.id);
          });
          setNotificationMediumDetails(filteredGenre);
        }
      } else {
        setNotificationMediumDetails([]);
      }
    }
  }, [notificationMediumList, loadedPolicy, resourcesLoading]);
  (0, _react.useEffect)(function () {
    if (!policy) {
      if ((0, _commonUtils.isLoading)(loadedPolicyStatus) || (0, _commonUtils.isLoading)(usersDataStatus) || (0, _commonUtils.isLoading)(groupsDataStatus) || (0, _commonUtils.isLoading)(serviceIdentitiesDataStatus) || (0, _commonUtils.isLoading)(tokensDataStatus) || (0, _commonUtils.isLoading)(notificationMediumDetailsStatus) || (0, _commonUtils.isLoading)(loadedPolicyJSONStatus) || (0, _commonUtils.isLoading)(consumersListStatus)) {
        setResourcesLoading(true);
      }

      if ((0, _commonUtils.isError)(loadedPolicyStatus) || (0, _commonUtils.isError)(usersDataStatus) || (0, _commonUtils.isError)(groupsDataStatus) || (0, _commonUtils.isError)(serviceIdentitiesDataStatus) || (0, _commonUtils.isError)(tokensDataStatus) || (0, _commonUtils.isError)(loadedPolicyJSONStatus) || (0, _commonUtils.isError)(notificationMediumDetailsStatus) || (0, _commonUtils.isError)(consumersListStatus)) {
        setResourcesLoading(false);
      }
    }

    if (!(0, _commonUtils.isLoading)(loadedPolicyStatus) && !(0, _commonUtils.isLoading)(usersDataStatus) && !(0, _commonUtils.isLoading)(groupsDataStatus) && !(0, _commonUtils.isLoading)(serviceIdentitiesDataStatus) && !(0, _commonUtils.isLoading)(tokensDataStatus) && !(0, _commonUtils.isLoading)(notificationMediumDetailsStatus) && !(0, _commonUtils.isLoading)(loadedPolicyJSONStatus) && !(0, _commonUtils.isLoading)(consumersListStatus)) {
      setResourcesLoading(false);
    }
  }, [loadedPolicyStatus, usersDataStatus, groupsDataStatus, tokensDataStatus, serviceIdentitiesDataStatus, notificationMediumDetailsStatus, loadedPolicyJSONStatus, consumersListStatus]);
  (0, _react.useEffect)(function () {
    loadPolicy(id, history, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath);
    setResourcesLoading(true);
    return function () {
      resetPolicy();
      resetPolicyJSON();
    };
  }, []);
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isSuccess)(loadedPolicyStatus)) {
      loadPolicyJSON(loadedPolicy === null || loadedPolicy === void 0 ? void 0 : loadedPolicy.name, history, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath);
    }
  }, [loadedPolicyStatus]);
  (0, _react.useEffect)(function () {
    initSpinnerOverlay({
      open: resourcesLoading,
      size: 'medium',
      message: _constants.translatedStrings.loadingPolicy
    });
  }, [resourcesLoading]);
  (0, _react.useEffect)(function () {
    if (!resourcesLoading) {
      var isEditMode = true;
      var constants = {
        inlineType: _constants.translatedStrings.inlineType,
        preDefinedType: _constants.translatedStrings.preDefinedType,
        consumersList: consumersList
      };

      if (!(0, _isEmpty.default)(loadedPolicy) && !policy) {
        setPolicy((0, _utils.massageLoadedPolicy)({
          policy: loadedPolicy,
          usersData: usersData,
          groupsData: groupsData,
          tokensData: tokensData,
          serviceIdentitiesData: serviceIdentitiesData,
          isEditMode: isEditMode,
          notificationMediumDetails: notificationMediumDetails
        }, _objectSpread({}, constants)));
      }

      if (!(0, _isEmpty.default)(loadedPolicyJSON) && !policyJSON) {
        setPolicyJSON((0, _utils.massageLoadedPolicyJSON)(loadedPolicyJSON, isEditMode, _objectSpread({}, constants)));
      }
    }
  }, [resourcesLoading, notificationMediumDetails, loadedPolicyJSON]);

  var resetHandler = function resetHandler() {
    setResetModalOpen(true);
  };

  var addPolicyFormProps = {
    usersData: usersData,
    usersDataStatus: usersDataStatus,
    groupsData: groupsData,
    groupsDataStatus: groupsDataStatus,
    serviceIdentitiesData: serviceIdentitiesData,
    serviceIdentitiesDataStatus: serviceIdentitiesDataStatus,
    tokensData: tokensData,
    tokensDataStatus: tokensDataStatus,
    consumersList: consumersList,
    resetActionsData: resetActionsData,
    setPageHeader: setPageHeader,
    fetchUsers: fetchUsers,
    fetchGroups: fetchGroups,
    fetchServiceIdentities: fetchServiceIdentities,
    fetchTokens: fetchTokens,
    fetchPermissionsList: fetchPermissionsList,
    fetchConsumersList: fetchConsumersList,
    fetchPermissionDetails: fetchPermissionDetails,
    fetchPermissionActions: fetchPermissionActions,
    fetchRolesList: fetchRolesList,
    fetchRoleDetails: fetchRoleDetails,
    history: history,
    editPolicy: {
      id: id,
      updatePolicy: updatePolicy,
      loadedPolicy: resourcesLoading ? null : policy,
      loadedPolicyJSON: resourcesLoading && !policy ? null : policyJSON,
      resetHandler: resetHandler,
      editPolicyErrors: editPolicyErrors,
      editPolicyStatus: editPolicyStatus,
      editReadOnly: loadedPolicy === null || loadedPolicy === void 0 ? void 0 : loadedPolicy.isReadOnly
    },
    openNotification: openNotification,
    initSpinnerOverlay: initSpinnerOverlay,
    permissionsListStatus: permissionsListStatus,
    getApplicationsList: getApplicationsList,
    applicationsListStatus: applicationsListStatus,
    applicationsListData: applicationsListData,
    consumerEntityId: consumerEntityId,
    redirectPath: redirectPath,
    validateChannelListStatus: validateChannelListStatus,
    validateChannelListError: validateChannelListError,
    validateChannelList: validateChannelList,
    isConditionTypeJSON: isConditionTypeJSON
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !resourcesLoading && /*#__PURE__*/_react.default.createElement(_AddPolicy.default, addPolicyFormProps), resetModalOpen && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    type: "alert",
    title: _constants.translatedStrings.resetEditTitle,
    message: _constants.translatedStrings.resetEditMessage,
    primaryButtonText: _constants.translatedStrings.resetEditPrimaryBtn,
    secondaryButtonText: _constants.translatedStrings.resetEditSecondaryBtn,
    onSubmit: function onSubmit() {
      setPolicy(null);
      setPolicyJSON(null);
      loadPolicy(id, history, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath);
      setResetModalOpen(false);
    },
    onCancel: function onCancel() {
      setResetModalOpen(false);
    }
  }));
};

EditPolicy.propTypes = {
  usersData: _propTypes.default.any,
  groupsData: _propTypes.default.any,
  serviceIdentitiesData: _propTypes.default.any,
  tokensData: _propTypes.default.any,
  resetActionsData: _propTypes.default.func,
  consumersList: _propTypes.default.any,
  editPolicyErrors: _propTypes.default.any,
  editPolicyStatus: _propTypes.default.string,
  loadedPolicy: _propTypes.default.any,
  loadedPolicyStatus: _propTypes.default.string,
  resetLoadedPolicy: _propTypes.default.func,
  history: _propTypes.default.any,
  setPageHeader: _propTypes.default.func,
  fetchUsers: _propTypes.default.func,
  fetchGroups: _propTypes.default.func,
  fetchServiceIdentities: _propTypes.default.func,
  fetchTokens: _propTypes.default.func,
  fetchPermissionsList: _propTypes.default.func,
  fetchConsumersList: _propTypes.default.func,
  fetchPermissionDetails: _propTypes.default.func,
  fetchPermissionActions: _propTypes.default.func,
  fetchRolesList: _propTypes.default.func,
  fetchRoleDetails: _propTypes.default.func,
  updatePolicy: _propTypes.default.func,
  openNotification: _propTypes.default.func,
  loadPolicy: _propTypes.default.func,
  initSpinnerOverlay: _propTypes.default.any,
  usersDataStatus: _propTypes.default.string,
  groupsDataStatus: _propTypes.default.string,
  serviceIdentitiesDataStatus: _propTypes.default.string,
  tokensDataStatus: _propTypes.default.string,
  permissionsListStatus: _propTypes.default.string,
  channelList: _propTypes.default.any,
  channelListStatus: _propTypes.default.string,
  getApplicationsList: _propTypes.default.func,
  applicationsListStatus: _propTypes.default.string,
  applicationsListData: _propTypes.default.array,
  loadedPolicyJSON: _propTypes.default.any,
  loadedPolicyJSONStatus: _propTypes.default.string,
  loadPolicyJSON: _propTypes.default.func,
  resetPolicy: _propTypes.default.func,
  resetPolicyJSON: _propTypes.default.func,
  consumersListStatus: _propTypes.default.string,
  consumerEntityId: _propTypes.default.string,
  redirectPath: _propTypes.default.string,
  validateChannelListStatus: _propTypes.default.string,
  validateChannelListError: _propTypes.default.string,
  validateChannelList: _propTypes.default.func,
  isConditionTypeJSON: _propTypes.default.bool
};
var _default = EditPolicy;
exports.default = _default;